import { render, staticRenderFns } from "./RecentJobs.vue?vue&type=template&id=1d2f9e04&"
import script from "./RecentJobs.vue?vue&type=script&lang=js&"
export * from "./RecentJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports